import React from 'react'
import { Formik } from 'formik'

import { Button, Form, Modal } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'
import Yup from '_zari/validation/_yup'

import { PartesDiaTurno } from 'constants/index'

import * as FormGroups from './formGroups'

import * as TurnoService from 'services/turno.service'

const AbrirTurno = ({ history }) => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const [mostrarModal, setMostrarModal] = React.useState(true)

  const formInitialValues = React.useMemo(
    () => ({
      idIsla: __adminContext._idIsla || '',
      efectivoInicio: 0,
      parteDia: PartesDiaTurno.MANANA
    }),
    [__adminContext]
  )

  const validationSchema = React.useMemo(() => {
    if (__adminContext.valoresConfiguracionUsuario.flagAtencionIsla && __adminContext.valoresConfiguracionCompania.flagGrifo) {
      return Yup.object().shape({
        idIsla: Yup.string().required(),
        efectivoInicio: Yup.number().min(0).required()
      })
    }

    return Yup.object().shape({
      efectivoInicio: Yup.number().min(0).required()
    })
  }, [__adminContext])

  const handleClose = React.useCallback(() => {
    setMostrarModal(false)
    history.push('/')
  }, [history])

  const submitHandler = async data => {
    await TurnoService.self
      .aperturarTurno(data)
      .then(() => {
        __zariContext.snack('success', 'El turno se ha aperturado.')
        __adminContext.setEstadoTurno(true)
        if (__adminContext.valoresConfiguracionCompania.flagGrifo) {
          __adminContext.setIdIslaActiva(data.idIsla)
        }
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={mostrarModal}>
      <Modal.Header>
        <Modal.Title>APERTURAR TURNO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={validationSchema}>
        {({ errors, handleSubmit, isSubmitting, setValues, touched, values }) => (
          <Form>
            <Modal.Body>
              <FormGroups.EfectivoInicioFormGroup
                fIsSubmitting={isSubmitting}
                iTouched={touched.efectivoInicio}
                iError={errors.efectivoInicio}
              />
              <FormGroups.ParteDiaFormGroup iValue={values.parteDia} fIsSubmitting={isSubmitting} />
              {__adminContext.valoresConfiguracionCompania.flagGrifo && (
                <FormGroups.IdIslaFormGroup
                  fIsSubmitting={isSubmitting}
                  iTouched={touched.idIsla}
                  iError={errors.idIsla}
                />)
              }
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit} disabled={isSubmitting}>
                Aperturar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(AbrirTurno)
